import type { ComponentProps } from 'react';
import { Platform, useColorScheme, View } from 'react-native';

import VidaLogoDark from '@/assets/icons/vida-logo-dark-mode.svg';
import VidaLogoLight from '@/assets/icons/vida-logo.svg';

type SvgProps = ComponentProps<typeof VidaLogoLight>;

type VidaLogoProps = SvgProps & {
  /**
   * Pass explicitly to override the system color scheme.
   * When omitted, the logo follows `useColorScheme()` automatically.
   */
  mode?: 'light' | 'dark';
};

export function VidaLogo({ mode, ...svgProps }: VidaLogoProps) {
  const scheme = useColorScheme();

  if (Platform.OS === 'web' && !mode) {
    return (
      <>
        <View className='dark:hidden'>
          <VidaLogoLight {...svgProps} />
        </View>
        <View className='hidden dark:flex'>
          <VidaLogoDark {...svgProps} />
        </View>
      </>
    );
  }

  const resolvedMode = mode ?? (scheme === 'dark' ? 'dark' : 'light');
  const Component = resolvedMode === 'dark' ? VidaLogoDark : VidaLogoLight;
  return <Component {...svgProps} />;
}
